// extracted by mini-css-extract-plugin
export default {"customerServiceText":"policy-list-item-subtitle_customerServiceText__BpmOK"};